import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SearchService {

  API_URL = environment.apiURL + 'cms/cursos/buscar/';

  constructor(private http: HttpClient) { }
  getSearchResults(search): Observable<any>{
    return this.http.get<any[]>(this.API_URL + search);
  }}
